export interface UserData {
  id: string;
  name: string;
  thumb?: string;
}

export enum Theme {
  LIGHT = "light",
  DARK = "dark",
  BLACK = "black",
  HACKER = "hacker_theme",
}

export interface Item {
  id: string;
  name: string;
  group: BoardGroup;
  column_values?: ItemColumnValue[];
  subitems: Item[] | undefined;
  parent_item?: Item;
  columnValuesPending: boolean | undefined;
}

export interface ItemColumnValue {
  id: string;
  value: string;
  text: string;
  label?: string;
  label_style?: { color: string };
}

export interface Workspace {
  id: string;
  name: string;
  settings: {
    icon: {
      image: string | null;
      color: string;
    };
  };
}

export interface Board {
  name: string;
  id: string;
  workspace: Workspace;
  type: string;
}

export interface BoardGroup {
  title: string;
  id: string;
  color: string;
  position: string;
}

export interface Group extends BoardGroup {
  items: Item[];
}

export interface GroupPaged extends BoardGroup {
  items_page: {
    cursor: string | null;
    items: Item[];
  };
}

export enum UserKind {
  ALL = "all",
  NON_GUESTS = "non_guests",
  GUESTS = "guests",
  NON_PENDING = "non_pending",
}

export enum BoardKind {
  PRIVATE = "private",
  PUBLIC = "public",
  SHARE = "share",
}

export enum CheckOption {
  NONE,
  FALSE,
  TRUE,
}
// Purpose: Service to call our CLI backend.
export type ExecutionId = {
  id: string;
};
// Manually derived from com.appfire.common.cli.ExitCode
export enum ExitCode {
  SUCCESS = "SUCCESS",
  CLIENT_EXCEPTION = "CLIENT_EXCEPTION",
  PARAMETER_PROBLEM = "PARAMETER_PROBLEM",
  HELP = "HELP",
  REMOTE_EXCEPTION = "REMOTE_EXCEPTION",
  CLIENT_SPECIFIC_EXCEPTION = "CLIENT_SPECIFIC_EXCEPTION",
  SQL_EXCEPTION = "SQL_EXCEPTION",
  FAILURE = "FAILURE",
}
export interface ResultType {
  duration: number;
  actionId: string;
  output: string;
  exitCode: ExitCode;
}

export interface PollResult {
  retry: boolean;
  success?: boolean;
  duration?: number;
  results?: Array<ResultType>;
  exitCode?: ExitCode;
  failureReason?: string;
}

export interface ActionResult {
  start: number;
  duration: number;
  results: Array<ResultType>;
  exitCode?: ExitCode;
  accountId?: string;
  automationId?: string;
  automationTitle?: string;
  trigger?: string;
}
